<template>
	<div id="preloader">
		<div id="loader">
			<div class="line-scale-pulse-out">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SectionPreloader'
	}
</script>



// WEBPACK FOOTER //
// src/components/sections/Preloader.vue